import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import { Status } from "layouts/common/columns";
import { Link } from "react-router-dom";
import { ActionMenu } from "layouts/common/buttons";
import { TextLink } from "layouts/common/buttons";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function data(centers, handleDelete) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  console.log("Raw centers:", centers); // 🔹 Check the raw data coming in

  const rows = () => {
    const sortedCenters = [...centers].sort((a, b) => {
      const numA = Number(a.centerId.match(/\d+$/)?.[0] || 0);
      const numB = Number(b.centerId.match(/\d+$/)?.[0] || 0);

      console.log("Sorting:", a.centerId, numA, b.centerId, numB); // 🔹 See how sort sees each pair
      return numA - numB;
    });

    console.log("Sorted centers:", sortedCenters.map(c => c.centerId)); // 🔹 Final order after sort

    return sortedCenters.map(center => {
      const centerNumber = center.centerId.replace(/\D/g, '');
      return {
        centerId: (
          <TextLink
            link={`/centers/${center.id}/detail`}
            text={centerNumber}
          />
        ),
        email:
          <MDTypography variant="caption" fontWeight="medium">
            {center.email}
          </MDTypography>,
        name:
          <MDTypography variant="caption" fontWeight="medium">
            {center.name}
          </MDTypography>,
        dropdown: (
          <ActionMenu
            entity={center}
            basePath="centers"
            onDelete={() => handleDelete(center.id)}
          />
        ),
      };
    });
  };

  const columns = [
    { Header: "Center no", accessor: "centerId", align: "left" },
    { Header: "Title", accessor: "name", align: "left" },
    !isMobile && { Header: "Email", accessor: "email", align: "left" },
    { accessor: "dropdown", align: "right" },
  ].filter(Boolean);

  return {
    columns: columns,
    rows: rows(),
  };
}
